import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async register(form) {
    await Csrf.getCookie();

    return Api.post("/register", form);
  },

  async login(form) {
    await Csrf.getCookie();

    return Api.post("/login", form);
  },

  async logout(form) {
    await Csrf.getCookie();

    return Api.post("/logout", form);
  },

  auth() {
    return Api.post("/user");
  },

  notifications() {
    return Api.get("/user/notifications");
  },

  markAsRead(id) {
    return Api.get("/user/notifications/mark-as-read/" + id);
  },

  bellNotifications() {
    return Api.get("/user/notifications/bell");
  },

  async updateSelf(form) {
    await Csrf.getCookie();

    return Api.patch("/user-self", form);
  },

  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/users/" + id, form);
  },

  async index() {
    await Csrf.getCookie();

    return Api.get("/users");
  },

  async getRole(role_id) {
    await Csrf.getCookie();

    return Api.get("/users/" + role_id);
  },

  async getRoles(array_of_role_ids) {
    await Csrf.getCookie();

    return Api.get("/users/" + array_of_role_ids.join("-"));
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/users", form);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/users/" + id);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/users/" + id + "/show");
  },

  async setPin(form) {
    await Csrf.getCookie();

    return Api.post("/users/set-pin", form);
  },

  async updatePassword(form) {
    await Csrf.getCookie();

    return Api.post("/users/update-password", form);
  },

  async setRoles(form) {
    await Csrf.getCookie();

    return Api.post("/users/set-roles", form);
  },

  async setPassword(form) {
    await Csrf.getCookie();

    return Api.post("/users/change-password", form);
  },

  async setTemporaryRole(form) {
    await Csrf.getCookie();

    return Api.post("/users/set-temporary-role", form);
  },

  async logs(id, event_id = null) {
    await Csrf.getCookie();

    if (event_id == null) {
      return Api.get("/users/" + id + "/logs");
    } else {
      return Api.get("/users/" + id + "/logs/" + event_id);
    }
  },

  async files(id) {
    await Csrf.getCookie();
    return Api.get("/users/" + id + "/files");
  },

  async getPermits() {
    await Csrf.getCookie();

    return Api.get("/users/permits");
  },

  async getPermitTypes() {
    await Csrf.getCookie();

    return Api.get("/users/permit-types");
  },

  async addPermit(form) {
    await Csrf.getCookie();

    return Api.post("/users/permits", form);
  },
  async deletePermit(id) {
    await Csrf.getCookie();

    return Api.delete("/users/permits/" + id);
  },
  async deleteFile(id) {
    await Csrf.getCookie();

    return Api.delete("/users/files/" + id);
  },

  async validatePin(data) {
    await Csrf.getCookie();

    return Api.post("/users/validate-pin", data);
  },

  async permitTypeReturnSign(data) {
    await Csrf.getCookie();

    return Api.post("/users/permit-types", data);
  },

  async usersWithPermits() {
    await Csrf.getCookie();

    return Api.get("/users/with-permits");
  },

  async updateUserPermit(id, data) {
    await Csrf.getCookie();

    return Api.put("/users/update-permit/" + id, data);
  },

  async systemMessages() {
    await Csrf.getCookie();

    return Api.get("/system-messages/user");
  },

  async markSystemMessagesAsRead() {
    await Csrf.getCookie();

    return Api.get("/system-messages/user/read");
  },
};
